import { GetAllSupportDocsByCode } from '~/domain/usecases/supportDoc/remote';
import {
  InvalidCredentialsError,
  UnexpectedError,
  NotFound,
} from '~/domain/errors';
import { HttpClient, HttpStatusCode } from '~/data/protocols/http';

export class RemoteGetAllSupportDocsByCode implements GetAllSupportDocsByCode {
  private readonly url: string;

  private readonly httpClient: HttpClient<GetAllSupportDocsByCode.Model>;

  constructor(
    url: string,
    httClient: HttpClient<GetAllSupportDocsByCode.Model>,
  ) {
    this.url = url;
    this.httpClient = httClient;
  }

  getAll = async (
    params: GetAllSupportDocsByCode.Params,
  ): Promise<GetAllSupportDocsByCode.Model> => {
    let query = '';

    const { code, ...rest } = params;

    Object.entries(rest).forEach(([key, value]) => {
      if (value) query += `${key}=${value}&`;
    });

    const httpResponse = await this.httpClient.request({
      url: `${this.url.replace('{code}', code)}?${query}`,
      method: 'get',
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.notFound:
        throw new NotFound();
      case HttpStatusCode.unauthorized:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError();
    }
  };
}
